import type { RequestConfig } from '@customTypes/index';
import type {
  PaginatedResponse,
  SearchArtistItemDto
} from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type SearchArtistsParams = RequestConfig;

export const searchArtists = async ({ config }: SearchArtistsParams) =>
  api.get<PaginatedResponse<SearchArtistItemDto[]>>(
    `/api/search/artists`,
    config
  );
